var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"app-card mx-4 my-3 px-4 elevation-3",attrs:{"elevation":"8","color":_vm.cardColor,"to":_vm.namedPath}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }